<template>
  <fieldset :class="cssClass">
    <legend :class="{ 'sr-only': !showTitle }">{{ title }}</legend>
    <div class="fields">
      <slot />
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    cssClass: {
      type: String,
      required: false,
      default: '',
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.fields {
  display: grid;
  grid-gap: 1em;
  margin-bottom: 1em;
}

fieldset {
  border: 0;
  padding: 0;
}
</style>
